import "./Experience.module.css";
import Header from "@/reusable_sections/Header";
import TheBlueprint from "./sections/TheBlueprint";
import TheCreativeLead from "./sections/TheCreativeLead";
import MainSiteFooter from "@/reusable_sections/Footer";
export default function ExperiencePage() {
  return <div>
      <Header />
      <TheBlueprint />
      <TheCreativeLead />
      <MainSiteFooter />
    </div>;
}